// Where an issue opens. The only issue page is the resolve page,
// /issue/:shareToken/resolve; analytics rows that carry just an id go
// through /issue-viewer/:id, which resolves the token and redirects.
export function issuePath(issue) {
  if (!issue) return "/issues";
  if (issue.shareToken) return `/issue/${issue.shareToken}/resolve`;
  const id = issue.id || issue._id;
  return id ? `/issue-viewer/${id}` : "/issues";
}
